<template>
  <Splitpanes class="default-theme">
    <Pane size="50" style="background: none">
      <slot name="canvas" v-bind="slotDataCanvas"></slot>
    </Pane>
    <Pane style="background: none; position: relative">
      <slot name="aside" v-bind="slotDataContent"></slot>
    </Pane>
    <Pane v-if="tagMode === 'showList'" style="background: none; position: relative; overflow: auto">
      <slot name="metadata" v-bind="slotMetadataContent"></slot>
    </Pane>
  </Splitpanes>
</template>

<style>
.splitpanes__splitter:hover {
  background-color: rgba(127, 0, 255, 0.25) !important;
}
</style>

<script>
import { Splitpanes, Pane } from "splitpanes";
import "splitpanes/dist/splitpanes.css";

import { createNamespacedHelpers } from "vuex";

const { mapState, mapActions, mapGetters } = createNamespacedHelpers("browser");

export default {
  components: { Splitpanes, Pane },
  props: {
    content: {
      type: [Array, Object],
      required: true
    }
  },
  watch: {
    selectedElements(elements) {
      this.content.forEach(element => {
        this.elementStates[element.id] = {
          ...this.elementStates[element.id],
          isSelected: elements.includes(element.id),
          isFocused: elements.includes(element.id),
          eventSource: this.eventSource
        };
      });
    }
  },
  data() {
    // FIXME: do highlighting, result snippet parsine here??
    return {
      elementStates: this.content.reduce(
        (obj, val) => ({
          ...obj,
          [val.id]: {
            isTextVisible: this.isTextVisible,
            isHighlighted: val.highlight,
            isSelected: false
          }
        }),
        {}
      ),
      isReady: false
    };
  },
  computed: {
    ...mapState(["selectedElements", "eventSource", "tagMode"]),
    slotDataCanvas() {
      return {
        handleElementClick: this.handleCanvasClick,
        elements: this.statefulElements
      };
    },
    slotDataContent() {
      return {
        handleElementClick: this.handleContentClick,
        elements: this.statefulElements
      };
    },
    slotMetadataContent() {
      return {
        handleElementClick: this.handleContentClick,
        elements: this.statefulElements
      };
    },
    statefulElements() {
      return this.content.map(element => ({
        ...this.elementStates[element.id],
        ...element
      }));
    }
  },
  beforeDestroy() {
    this.clearSelectedElements();
  },
  methods: {
    ...mapActions([
      "toggleSelectedElement",
      "clearSelectedElements",
      "setEventSource"
    ]),
    handleCanvasClick(id) {
      this.setEventSource("canvas");
      this.toggleSelectedElement(id);
    },
    handleContentClick(id) {
      this.setEventSource("content");
      this.toggleSelectedElement(id);
    }
  }
};
</script>
